<template>
	<div>
		<div class="ai-chat-banner" @click="$refs.chatBtn.toggleDrawer()">
			<img :src="require('@/assets/AI-Chat-24px.svg')" class="ai-chat-icon" alt="AI" />
			<span class="ai-chat-text">Ask a question...</span>
		</div>
		<ChatMgButton ref="chatBtn" :hover="false" class="hidden-chat-trigger" />
	</div>
</template>

<script>
import ChatMgButton from './ChatMgButton.vue';

export default {
	components: { ChatMgButton },
};
</script>

<style scoped>
.ai-chat-banner {
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 12px;
	background: rgba(51, 40, 71, 0.05);
	border-radius: 8px;
	margin-bottom: 16px;
}

.ai-chat-icon {
	width: 24px;
	height: 24px;
	flex-shrink: 0;
}

.ai-chat-text {
	font-size: 15px;
	color: var(--brand-purple);
}

.hidden-chat-trigger :deep(.headerImage) {
	display: none;
}
</style>
